import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOntluchten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M34 12h-9.46A3.55 3.55 0 0 0 21 15.56V35h13z"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M30.103 18.5a2.44 2.44 0 0 0-2.433 2.44V35h-2V20.94a4.44 4.44 0 0 1 4.427-4.44z"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M20 20v11a5.77 5.77 0 0 1-6-5.5 5.77 5.77 0 0 1 6-5.5"
    />
    <path
      fill="#60D15D"
      d="M6 11.63a3.62 3.62 0 0 0 1.77 3.11 3.63 3.63 0 1 0 5.49 3.11q.015-.26 0-.52h5.66A1.12 1.12 0 0 0 20 16.22v-2.95a1.12 1.12 0 0 0-1.12-1.12h-5.66a4 4 0 0 0 0-.52A3.628 3.628 0 0 0 8.2 8.276a3.63 3.63 0 0 0-2.24 3.354zm3.63 7.78a1.56 1.56 0 1 1 0-3.12 1.56 1.56 0 0 1 0 3.12m1.56-7.78a1.56 1.56 0 1 1-3.12 0 1.56 1.56 0 0 1 3.12 0"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M10.847 15.127a3 3 0 0 0-3.96 1.517l-.914-.408a4 4 0 0 1 5.28-2.023zM21.5 6.29V14h-1V6.29zM23.5 9v4h-1V9zM18.5 13V9h1v4z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22.285 5.387a.79.79 0 0 0-.787.859l-.996.088a1.79 1.79 0 0 1 1.783-1.947 1.79 1.79 0 0 1 1.785 1.925 1.78 1.78 0 0 1-1.78 1.758v-1a.78.78 0 0 0 .78-.78v-.022l.002-.022a.79.79 0 0 0-.787-.86M18.012 8.27a.79.79 0 1 0-.302 1.52v1A1.79 1.79 0 1 1 19.5 9h-1a.79.79 0 0 0-.488-.73"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOntluchten);

export default ForwardRef;
